import {DEFAULT_API_REQ_VALUE, METHOD} from './constants';

export const createDefaultContent = () => {
  return {
    url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
    method: METHOD.GET,
    value: DEFAULT_API_REQ_VALUE,
  }
};
